export const name = 'pd_acknowledge';
export const label = 'Acknowledge Incident';
export const AdditionalParams = () => null;
export const type = 'incident_create,incident_update';
